<template>
    <div class="main-body">
        <div class="header">
            事故记录
        </div>
        <div class="out">

            <div class="search2">
              <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>
              <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" :data="tableData" :height="th" border style="width: 100%;">

                <el-table-column prop="title" label="标题"></el-table-column>

                <el-table-column prop="remarks" label="描述"></el-table-column>

                <el-table-column prop="createTime" :formatter="formatTime" label="创建时间"></el-table-column>


                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:options="options" v-on:closeAdd="closeAdd" v-on:init="init"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:options="options" v-on:closeEdit="closeEdit" v-on:init="init"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                options:[]
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.init();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init:function(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AccidentRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    //console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.init();
            },
            //格式化时间（2020-05-13T10:38:19.000+0800）
            formatTime:function (row, column, cellValue) {
                console.log(cellValue)
                var year = cellValue.substr(0, 4)
                var month = cellValue.substr(5, 2)
                var day = cellValue.substr(8, 2)
                var hour = cellValue.substr(11, 2)
                var min = cellValue.substr(14, 2)
                console.log(year + "-" + month + "-" + day + " " + hour + ":" + min);
                return year + "-" + month + "-" + day + " " + hour + ":" + min;
            }

        }
    }
</script>

<style lang="scss" scoped>
    .BerthPage{
        .el-button{
            transform: translate(-1px,0);
        }
    }
</style>
